import { LINK_SPI_GUIDANCE } from '../../constants/links';

function Guidance() {
  return (
    <div
      className="nhsuk-grid-column-one-half"
      aria-labelledby="guidance-heading"
    >
      <h2 className="landing-page__heading">SPI guidance</h2>
      <p className="nhsuk-u-margin-bottom-1">For help using SPI,</p>
      <p className="nhsuk-u-margin-bottom-4">click the link below.</p>
      <div className="nhsuk-u-margin-bottom-4">
        <a
          href={LINK_SPI_GUIDANCE}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="guidance-link"
          aria-label="Access SPI guidance documentation (opens in a new tab)"
          className="nhsuk-u-margin-bottom-4"
        >
          SPI guidance
        </a>
      </div>
    </div>
  );
}

export default Guidance;
